<div class="schedule-and-remote-work-compliance-details">
  @if (compliance_data(); as data) {
    <div class="month-stats">
      <div class="month-stat-chip">
        <span class="month-stat-label">Desfase medio</span>
        <span class="month-stat-value">
          {{ data.average_offset_minutes | number: '1.0-0' }}
          <span class="month-stat-unit">min</span>
        </span>
      </div>

      <div class="month-stat-chip">
        <span class="month-stat-label">Racha actual</span>
        <span class="month-stat-value">
          @if (streak_emoji()) {
            <span class="streak-icon">{{ streak_emoji() }}</span>
          }
          {{ data.current_streak }}
          <span class="month-stat-unit">{{ streak_unit() }}</span>
        </span>
      </div>
    </div>

    @if (has_calendar_data()) {
      <button mat-stroked-button class="calendar-button" (click)="openCalendarDialog()">
        <mat-icon>visibility</mat-icon>
        Ver detalle
      </button>
    }
  } @else {
    <p class="no-data">Aún no hay datos para evaluar este KPI.</p>
  }
</div>
